import { render, staticRenderFns } from "./PopoverEducationOptions.vue?vue&type=template&id=625c40e0&scoped=true"
import script from "./PopoverEducationOptions.vue?vue&type=script&lang=js"
export * from "./PopoverEducationOptions.vue?vue&type=script&lang=js"
import style0 from "./PopoverEducationOptions.vue?vue&type=style&index=0&id=625c40e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c40e0",
  null
  
)

export default component.exports